import { useDispatch } from 'react-redux';
import { MODAL_FORM } from 'constants/form';
import { openModal } from 'actions/modal';
import MODAL from 'constants/modal';

const useLogic = ({ teachers, date, slotStartTime, slotEndTime }) => {
  const dispatch = useDispatch();
  const isDisabled = !teachers?.length;
  const openTeachersListingModal = () =>
    !isDisabled &&
    dispatch(
      openModal(
        MODAL_FORM.AC_LED_MAPPING_TEACHERS_MODAL,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
          overflowY: 'hidden',
          height: MODAL.UPDATE_HEIGHT,
        },
        {
          teachers,
          date,
          slotStartTime,
          slotEndTime,
        },
      ),
    );

  return {
    openTeachersListingModal,
    isDisabled,
  };
};

export default useLogic;
